import styles from "./ArticleDek.module.scss";
import { gql } from "utils/urql";
import { ArticleSwanDekFragment, ArticleLayout } from "types/api";
import cx from "classnames";

const ArticleDek = ({ dek, layout }: ArticleSwanDekFragment) => {
  if (!dek) return null;
  return (
    <p
      className={cx(
        styles.root,
        layout === ArticleLayout.Feature && styles.feature,
        layout === ArticleLayout.Twocol && styles.twoCol
      )}
      dangerouslySetInnerHTML={{ __html: dek }}
    />
  );
};

export default ArticleDek;

ArticleDek.fragment = gql`
  fragment articleSwanDek on Article {
    dek
    layout
  }
`;
